import { Role } from './role';
import { Authority } from './authority';

export type UserObjectType = 'AdminUser' | 'B2bUser';

export type UserStatus = 'ENABLED' | 'LOCKED' | 'DISABLED';



export class User {
    userId: string;
    username: string;
    status: UserStatus;
    loginFailCount: number;
    isForceChangePassword: boolean;
    userPassword: string;
    companyName: string;
    companyShortName: string;
    companyCode: string;
    companyEmail: string;
    companyDescription: string;
    companyPhone: string;
    orderNoPrefix: string;
    firstName: string;
    lastName: string;
    userEmail: string;
    roles: Role[];
    userNo:string;
    authorities: Authority[];
    contactNoCountryCode: string;
    contactNo: string;
    workingDomain: string;

    availableHtmlTemplateNames: string;

    integrateWithRabbitchop: string;

    //for UI
    _selected: boolean;

    constructor() {
        this.status = 'ENABLED';
        this.roles = [null];
    }
}

export class UserSearchingCriteria {
    username: string;
    nameOfUser: string;
    roleId: string;
    status: UserStatus;
}

